import type { VFC } from 'react';

import { CategoryButtonList } from '~/components/CategoryButtonList/CategoryButtonList';
import { MostCommonQuestions } from '~/components/MostCommonQuestions/MostCommonQuestions';
import { SearchHeader } from '~/components/SearchHeader/SearchHeader';

export const LandingPage: VFC = () => (
  <>
    <SearchHeader />
    <CategoryButtonList />
    <MostCommonQuestions />
  </>
);
